module.exports = __webpack_public_path__ + "img/ins.15875761.png";